import PropTypes from "prop-types";

export const MapMarkerModel = {
    id: PropTypes.number,
    isSelected: PropTypes.bool,
    contactType: PropTypes.number,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    locationId: PropTypes.number,
    displayName: PropTypes.string,
    addressInfo: PropTypes.string,
    marker: PropTypes.object,
    icon: PropTypes.string,
};
